



























































































































































import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import AbpBase from '../../lib/abpbase'
import ArticleApi from '@/api/article/index'
@Component({
  components: {}
})
export default class ArticleDetail extends AbpBase {
  form: any = {
    title: null,
    description: null,
    categoryId: null,
    labels: [],
    images: [],
    content: null,
    isActive: true,
    guidance: true,
    discovery: true,
    relatedProducts: []
  }

  categoryList = []
  labelList = []

  comments = {
    totalCount: 0,
    currentPage: 1,
    maxResultCount: 10
  }
  commentList = []

  created() {
    this.getCategoryList()
    this.getLabelList()
    this.getArticleDetail()
    this.getArticleComment()
  }

  /**
   * 获取文章详情
   */
  getArticleDetail() {
    let id = this.$route.query['id']
    if (id) {
      ArticleApi.getArticleDetail(id.toString()).then(res => {
        if (res.data) {
          if (!res.data.relatedProducts) {
            res.data.relatedProducts = []
          }
          if (!res.data.labels || res.data.labels.length == 0) {
            res.data.labels = []
          }
          this.form = res.data
        }
      })
    }
  }

  /**
   * 获取所有文章分类
   */
  getCategoryList() {
    ArticleApi.getCategoryList().then(res => {
      this.categoryList = res.data.items
    })
  }

  /**
   * 获取所有文章标签
   */
  getLabelList() {
    ArticleApi.getLabelList().then(res => {
      this.labelList = res.data.items
    })
  }

  /**
   * 获取评论列表
   */
  getArticleComment() {
    let id = this.$route.query['id']
    if (id) {
      ArticleApi.getArticleComment(
        id.toString(),
        this.comments.maxResultCount,
        this.comments.currentPage
      ).then(res => {
        this.commentList = res.data.items
        this.comments.totalCount = res.data.totalCount
      })
    }
  }

  /**
   * 显示/隐藏文章评论
   */
  showOrhiddenComment(id) {
    ArticleApi.showOrhiddenComment(id).then(res => {
      this.getArticleComment()
    })
  }

  changePage(e) {
    this.comments.currentPage = e
    this.getArticleComment()
  }
  pageSizeChange(e) {
    this.comments.maxResultCount = e
    this.comments.currentPage = 1
    this.getArticleComment()
  }
}
